import { OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { of } from 'rxjs';
import { switchMap } from 'rxjs/internal/operators/switchMap';
import { MenuCategory } from '../../shared/menu/menu-category.model';
import { FullMenuService } from '../full-menu.service';
var FullMenuOptionComponent = /** @class */ (function () {
    function FullMenuOptionComponent(activeRoute, fullMenuService) {
        this.activeRoute = activeRoute;
        this.fullMenuService = fullMenuService;
    }
    FullMenuOptionComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.shouldLoadOptionAndMakeScrollIntoCategory();
        this.fullMenuService.getSortType().subscribe(function (sortType) {
            if (_this.selectedSortType !== sortType) {
                _this.selectedSortType = sortType;
            }
        });
        this.fullMenuService.getMenuTabindex().subscribe(function (menuTabIndex) {
            _this.menuTabIndex = menuTabIndex;
        });
    };
    FullMenuOptionComponent.prototype.ngAfterViewInit = function () {
        this.shouldLoadOptionAndMakeScrollIntoCategory();
    };
    FullMenuOptionComponent.prototype.ngOnChanges = function () {
        this.menuName = this.menuOption.name;
        this.translationKey = this.menuOption.translationKey;
        this.itemsCount = 0;
        if (this.menuOption.subMenus) {
            this.itemsCount = this.menuOption.subMenus.length;
            this.subCategory = Array.from(new Set(this.menuOption.subMenus.map(function (x) { return x.subCategory; })));
            this.subCategory = this.subCategory.slice().sort(function (sc1, sc2) {
                if (sc1 == null) {
                    return -1;
                }
                if (sc1 != null) {
                    return 1;
                }
                return 0;
            });
        }
    };
    FullMenuOptionComponent.prototype.getMenuItemList = function (subCategory) {
        return this.fullMenuService.sortMenu(this.menuOption.subMenus.filter(function (menu) { return subCategory === menu.subCategory; }));
    };
    FullMenuOptionComponent.prototype.shouldLoadOptionAndMakeScrollIntoCategory = function () {
        var _this = this;
        if (this.shouldLoadOption) {
            setTimeout(function () { _this.scrollIntoCategory(); });
        }
    };
    FullMenuOptionComponent.prototype.onExpandPanel = function (elementName) {
        document.getElementById('icon_' + elementName).className = "icon-arrow-down";
        document.getElementById('title_' + elementName).className += " menu-option-expansion-panel-title-orange";
    };
    FullMenuOptionComponent.prototype.onCollapsePanel = function (elementName) {
        var title = document.getElementById('title_' + elementName);
        document.getElementById('icon_' + elementName).className = "icon-arrow-up";
        title.className = title.className.replace("menu-option-expansion-panel-title-orange", "");
        this.shouldLoadOptionAndMakeScrollIntoCategory();
    };
    FullMenuOptionComponent.prototype.scrollIntoCategory = function () {
        var element;
        var header = 0;
        if (document.getElementById("header") != null && document.getElementById("header").offsetHeight != null)
            header = document.getElementById("header").offsetHeight;
        if (this.activeRoute && this.activeRoute.paramMap) {
            this.activeRoute.paramMap.pipe(switchMap(function (params) {
                return of(params.get('category'));
            })).subscribe(function (category) {
                if (category)
                    element = document.getElementById('title_' + category);
            });
        }
        if (element) {
            var scrollElm = document.scrollingElement;
            scrollElm.scrollTop = element.offsetTop - header;
        }
    };
    FullMenuOptionComponent.prototype.hasMoreThanOneItem = function () {
        return this.itemsCount > 1;
    };
    Object.defineProperty(FullMenuOptionComponent.prototype, "isExpanded", {
        get: function () {
            return (this.selectedCategoryName == null || !this.selectedCategoryName) ? true : this.menuName == this.selectedCategoryName;
        },
        enumerable: true,
        configurable: true
    });
    return FullMenuOptionComponent;
}());
export { FullMenuOptionComponent };
